import {Component, Input, OnInit} from '@angular/core';
import {Line } from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-line-setting',
  templateUrl: './line-setting.component.html',
  styleUrls: ['./line-setting.component.css']
})
export class LineSettingComponent implements OnInit {
  @Input()
  line: Line = new Line();
  itemValue: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(value:VariableValue): string
  {
    return sprintf("%5.1f", value.val / 1);
  }

  ngOnInit(): void {
    this.itemValue = this.variableDB.AddValueByReference(this.line.variable.id);
  }



}
